import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ArrHlp } from 'src/lib/fliko/helpers/array.helper';
import { DownloadFileCtx } from 'src/lib/fliko/models/http/downloadFile.data';
import { FileInStorageHlp } from '../../helpers/file.helper';
import { FileData, FileInStorageData } from '../../models/file.data';
import { FireStorageService } from '../../services/storage.service';

@Component({
  selector: 'app-image-preview-list',
  templateUrl: './image-preview-list.component.html',
  styleUrls: ['./image-preview-list.component.scss']
})
export class ImagePreviewListComponent implements OnChanges {
  @Input() images: FileInStorageData[] = [];
  @Input() imagesRawData: FileData[] = [];
  @Input() label: boolean = true;
  @Input() fileLocation?: string;
  @Input() downloadContext?: Omit<DownloadFileCtx, 'storagePath' | 'fileUrl'>;

  public imagesWithSizes: FileInStorageData[] = [];

  constructor(private fs: FireStorageService) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (changes.images) {
      const prevImg: FileInStorageData[] = changes.images.previousValue || [];
      const currImg: FileInStorageData[] = changes.images.currentValue || [];

      if (ArrHlp.checkDifferences(currImg, prevImg, FileInStorageHlp.areEqual) === currImg.length) this.imagesWithSizes = [];

      this.imagesWithSizes = await FileInStorageHlp.copyAndAppendFiles(
        changes.images.currentValue,
        this.imagesWithSizes,
        this.fs
      );
    }
  }
}
